module.exports = __webpack_public_path__ + "img/logocontent.c9bb2942.png";